module.exports = __webpack_public_path__ + "static/media/awaiting_inspection.be4d9da8.jpg";